import React from 'react';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import type { InspirationCategoryCarouselProps } from 'src/components/organisms/InspirationCategoryCarousel/InspirationCategoryCarousel';
import { InspirationCategoryCarousel } from 'src/components/organisms/InspirationCategoryCarousel/InspirationCategoryCarousel';
import * as styles from './InspirationPostsSection.styles';

export type InspirationPostsSectionProps = InspirationCategoryCarouselProps;

export const InspirationPostsSection = (props: InspirationPostsSectionProps) => (
  <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.wrapper}>
    <InspirationCategoryCarousel {...props} />
  </SectionContainer>
);
